import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[agencyCoreAlphanumeric]',
  standalone: true
})
export class AlphanumericDirective {
  // Updated regex to allow letters, numbers, spaces, and commas
  @Input() maxLengthWords: any = 150
  private regex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFFa-zA-Z0-9\s,]*$/;

  constructor(private el: ElementRef, private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(
      /[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFFa-zA-Z0-9\s,]/g,
      ''
    );

    if (input.value !== cleaned) {
      input.value = cleaned;
      this.ngControl.control?.setValue(cleaned);
    }
  }


  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const key = event.key;
    const current: string = this.el.nativeElement.value;

    if (!this.regex.test(key) || current.length >= this.maxLengthWords) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedText: string = event.clipboardData?.getData('text') || '';
    const current: string = this.el.nativeElement.value;

    if (!this.regex.test(pastedText) || (current.length + pastedText.length > this.maxLengthWords)) {
      event.preventDefault();
    }
  }
}
